import { PhoneNumber } from "../misc/PhoneNumber";
import { useRecordContext, useTranslate } from "ra-core";
import { CreateButton } from "@/components/admin/create-button";
import { DataTable } from "@/components/admin/data-table";
import { ExportButton } from "@/components/admin/export-button";
import { List } from "@/components/admin/list";
import { SearchInput } from "@/components/admin/search-input";
import { Badge } from "@/components/ui/badge";

import { getSalesRoleLabel, effectiveRole } from "./roles";
import { RemoveEmployeesButton } from "./RemoveEmployeesButton";
import { TopToolbar } from "../layout/TopToolbar";

const SalesListActions = () => (
  <TopToolbar>
    <ExportButton />
    <CreateButton label="resources.sales.action.new" />
  </TopToolbar>
);

const filters = [<SearchInput source="q" alwaysOn />];

const OptionsField = (_props: { label?: string | boolean }) => {
  const record = useRecordContext();
  const translate = useTranslate();
  if (!record) return null;
  return (
    <div className="flex flex-row gap-1">
      {record.hidden_from_team && (
        <Badge variant="outline">Скрыт от команды</Badge>
      )}
      {record.disabled && (
        <Badge
          variant="outline"
          className="border-orange-300 dark:border-orange-700"
        >
          {translate("resources.sales.fields.disabled")}
        </Badge>
      )}
    </div>
  );
};

export function SalesList() {
  return (
    <List
      filters={filters}
      actions={<SalesListActions />}
      sort={{ field: "first_name", order: "ASC" }}
    >
      <DataTable bulkActionButtons={<RemoveEmployeesButton />}>
        <DataTable.Col source="first_name" />
        <DataTable.Col source="last_name" />
        <DataTable.Col source="email" />
        <DataTable.Col
          source="phone"
          label="Телефон"
          render={(record) => <PhoneNumber value={record.phone} />}
        />
        <DataTable.Col
          source="role"
          label="Роль"
          render={(record) => getSalesRoleLabel(effectiveRole(record))}
        />
        <DataTable.Col label="Статус">
          <OptionsField />
        </DataTable.Col>
      </DataTable>
    </List>
  );
}
